const Nav = ({ className, item, onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e, item.link);
    }
  };

  return (
    <li className={className}>
      <a href={item.link} onClick={handleClick}>
        {item.icon}
      </a>
    </li>
  );
};

export default Nav;
